import React from 'react';

export const PageNotFound: React.FC = () => {
  return <div>404</div>;
};
